exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-slide-toggle {\n  margin-top: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/CustomersModule/CustomerEditComponent/customer-edit.component.scss
// module id = ../../../../../src/CustomersModule/CustomerEditComponent/customer-edit.component.scss
// module chunks = main